import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';
import { HeicCertModel } from 'src/app/models/heic_cert.model';
import { JobService } from 'src/app/services/job/job.service';
import { Constants } from 'src/app/constants/constants';
import { JobModel } from 'src/app/models/job.model';
import { AssetModel } from 'src/app/models/asset.model';


@Component({
  selector: 'modal-cert-preview',
  templateUrl: './modal-cert-preview.component.html',
  styleUrls: ['./modal-cert-preview.component.scss'],
})
export class ModalCertPreviewComponent implements OnInit {


  selectedJob: JobModel;
  copiedJob: JobModel;

  additionalPages: any = [];
  address: string;

  observations: any = [];

  twentyEightRows: Array<AssetModel> = [];
  twentyEightRowsTwo: Array<AssetModel> = [];
  twentyEightRowsThree: Array<AssetModel> = [];

  obsPage = true;

  @ViewChild('popover') popover;
  isOpen = false;
  selectedField: any;



  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController,
   public assetService: AssetService, public clientService: ClientService, 
   private jobService: JobService) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    // First page has 5 assets.
    this.copiedJob = JSON.parse(JSON.stringify(this.selectedJob));

    this.observations = [];

    for (var i = 0; i < this.copiedJob.assets.length; i++)
    {
      var asset = this.copiedJob.assets[i];

      if(!asset.assetType.isStreetLight)
      {
        this.copiedJob.assets.splice(i, 1);
        continue;
      }
      
      var condition = "";
      var obsInfo = "";
      var breakdownString = "";

      for (var x = 0; x < asset.observations.length; x++)
      {
        var obs = asset.observations[x];

        condition = obs.conditionCode;

        if (obs.repairedOnJobUid)
        {
          obsInfo = obs.repairNotes ? "[Repair] " + obs.repairNotes : "[Repair] ";
        }
        else if (obs.recommendedOnJobUid)
        {
          obsInfo = obs.observationInfo ? "[Recommended] " + obs.observationInfo : "[Recommended] ";
        }
        else
        {
          obsInfo = obs.observationInfo ? obs.observationInfo : "";
        }

        for (var z = 0; z < obs.chosenRemedials.length; z++)
        {
          breakdownString += obs.chosenRemedials[z].name + ", ";
        }

        if (breakdownString == "")
        {
          breakdownString = obsInfo;
        }
        else
        {
          breakdownString = breakdownString.substring(0, breakdownString.length-2);
          breakdownString = obsInfo + " (" + breakdownString + ")";
        }
      }

      if (condition != "")
      {
        var assetObs = {
          assetName: asset.name,
          observations: breakdownString,
          conditionCode: condition
        }

        this.observations.push(assetObs);
      }
    }

    this.address = this.copiedJob.addressOne + ", " + this.copiedJob.addressTwo + ", " + this.copiedJob.addressCity + ", " + this.copiedJob.postCode;

    // Each additional page holds 28 assets.

    if (this.copiedJob.assets.length > 5)
    {
      for (var i = 5; i < 33; i++)
      {
        if (this.copiedJob.assets[i])
        {
          this.twentyEightRows.push(this.copiedJob.assets[i]);
        }
      }

      this.additionalPages.push(this.twentyEightRows);
    }

    if (this.copiedJob.assets.length > 33)
    {
      for (var i = 33; i < 61; i++)
      {
        if (this.copiedJob.assets[i])
        {
          this.twentyEightRowsTwo.push(this.copiedJob.assets[i]);
        }
      }

      this.additionalPages.push(this.twentyEightRowsTwo);
    }

    if (this.copiedJob.assets.length > 61)
    {
      for (var i = 61; i < 89; i++)
      {
        if (this.copiedJob.assets[i])
        {
          this.twentyEightRowsThree.push(this.copiedJob.assets[i]);
        }
      }

      this.additionalPages.push(this.twentyEightRowsThree);
    }
  }


  openPopover(field, e: Event) 
  {
    this.selectedField = field;
    this.popover.event = e;
    this.isOpen = true;
  }


  certSettingChanged(choice)
  {
    switch(this.selectedField)
    {
      case 'bandOneAndTwo':
        this.copiedJob.heicCertificate.bandOneAndTwo = choice;
        break;

      case 'presenceOfIsolationSwitching':
        this.copiedJob.heicCertificate.presenceOfIsolationSwitching = choice;
        break;

      case 'supplyIntakeCond':
        this.copiedJob.heicCertificate.supplyIntakeCond = choice;
        break;

      case 'presenceEarthConductor':
        this.copiedJob.heicCertificate.presenceEarthConductor = choice;
        break;

      case 'adaquacyOfAccess':
        this.copiedJob.heicCertificate.adaquacyOfAccess = choice;
        break;

      case 'presenceOfCpc':
        this.copiedJob.heicCertificate.presenceOfCpc = choice;
        break;

      case 'presenceOfDiagrams':
        this.copiedJob.heicCertificate.presenceOfDiagrams = choice;
        break;

      case 'singlePoleDevices':
        this.copiedJob.heicCertificate.singlePoleDevices = choice;
        break;

      case 'sElvPelvFelv':
        this.copiedJob.heicCertificate.sElvPelvFelv = choice;
        break;

      case 'presenceBondingConstructor':
        this.copiedJob.heicCertificate.presenceBondingConstructor = choice;
        break;

      case 'idOfConductors':
        this.copiedJob.heicCertificate.idOfConductors = choice;
        break;

      case 'measuresExternalInfluence':
        this.copiedJob.heicCertificate.measuresExternalInfluence = choice;
        break;

      case 'doubleInsualtion':
        this.copiedJob.heicCertificate.doubleInsualtion = choice;
        break;

      case 'choiceSettingProtDevices':
        this.copiedJob.heicCertificate.choiceSettingProtDevices = choice;
        break;

      case 'surgePresentAndOk':
        this.copiedJob.heicCertificate.surgePresentAndOk = choice;
        break;

      case 'electSeperation':
        this.copiedJob.heicCertificate.electSeperation = choice;
        break;

      case 'selectionOfConductors':
        this.copiedJob.heicCertificate.selectionOfConductors = choice;
        break;

      case 'insualtionOfLiveParts':
        this.copiedJob.heicCertificate.insualtionOfLiveParts = choice;
        break;

      case 'presenceOfRcds':
        this.copiedJob.heicCertificate.presenceOfRcds = choice;
        break;

      case 'installtionMethods':
        this.copiedJob.heicCertificate.installtionMethods = choice;
        break;

      case 'barriersEnclosure':
        this.copiedJob.heicCertificate.barriersEnclosure = choice;
        break;

      case 'protectedAgainstMechDamage':
        this.copiedJob.heicCertificate.protectedAgainstMechDamage = choice;
        break;

      case 'placingOutOfReach':
        this.copiedJob.heicCertificate.placingOutOfReach = choice;
        break;

      case 'proxToNonElectricalServices':
        this.copiedJob.heicCertificate.proxToNonElectricalServices = choice;
        break;

      case 'connectionOfConductors':
        this.copiedJob.heicCertificate.connectionOfConductors = choice;
        break;

      case 'rcdFunctionalTestOk':
        this.copiedJob.heicCertificate.rcdFunctionalTestOk = choice;
        break;

    }
  }


  markOverallSummary(choice)
  {
    this.copiedJob.heicCertificate.overallSummary = choice;

    var removeOne = "See defects/observations. I further declare that in my judgement, the said installation was overall in Unsatisfactory condition at the time the inspection was carried out.";
    var removeTwo = "See defects/observations. I further declare that in my judgement, the said installation was overall in Satisfactory condition at the time the inspection was carried out.";

    if (this.copiedJob.heicCertificate.remarks)
    {
      this.copiedJob.heicCertificate.remarks = this.copiedJob.heicCertificate.remarks.replace(removeOne,'');
      this.copiedJob.heicCertificate.remarks = this.copiedJob.heicCertificate.remarks.replace(removeTwo,'');
    }

    var add = "See defects/observations. I further declare that in my judgement, the said installation was overall in " + choice + " condition at the time the inspection was carried out.";
    
    if (this.copiedJob.heicCertificate.remarks)
    {
      this.copiedJob.heicCertificate.remarks = add + this.copiedJob.heicCertificate.remarks;
    }
    else
    {
      this.copiedJob.heicCertificate.remarks = add;
    }
  }


  ionViewWillLeave()
  {

  }


  createCert()
  {
    var assetsToUpdate = [];
    var updateHeicCert = null;

    for (var i = 0; i < this.selectedJob.assets.length; i++)
    {
      var assetUid = this.selectedJob.assets[i].uid;
      var originalFields = this.selectedJob.assets[i].fields;

      for (var x = 0; x < this.copiedJob.assets.length; x++)
      {
        var copyAssetUid = this.copiedJob.assets[x].uid;

        if (copyAssetUid == assetUid)
        {
          var copiedFeilds = this.copiedJob.assets[x].fields;

          if (JSON.stringify(originalFields) != JSON.stringify(copiedFeilds))
          {
            assetsToUpdate.push(this.copiedJob.assets[i]);
          }

          break;
        }
      }
    }

    var original = this.selectedJob.heicCertificate;
    var updated = this.copiedJob.heicCertificate;

    if (JSON.stringify(original) != JSON.stringify(updated))
    {
      updateHeicCert = updated;
    }

    if (assetsToUpdate.length == 0)
    {
      assetsToUpdate = null;
    }

    var payload = {
      jobUid: this.selectedJob.jobUid,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetsToUpdate: assetsToUpdate,
      heicCertToUpdate: updateHeicCert
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.jobService.createHeicCertificate(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          var returnData = { certCreated: true };
          this.closeModal(returnData);
          this.appearanceService.presentToast("Certificate Created.", Constants.TOAST_SUCCESS);
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);

          // Settings might have updated, so I'm going to reload
          if (payload.assetsToUpdate || payload.heicCertToUpdate)
          {
            var returnData = { certCreated: true };
            this.closeModal(returnData);
          }
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
        
        // Settings might have updated, so I'm going to reload
        if (payload.assetsToUpdate || payload.heicCertToUpdate)
        {
          var returnData = { certCreated: true };
          this.closeModal(returnData);
        }

      });
    });
  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'ModalCertPreview');
  }
}
